import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { UserService } from '@shared/services/user.service';
import { Roles } from '@app/shared/enums/roles.enum';

export const RoleGuard: CanActivateFn = route => {
  const userService = inject(UserService);
  const router = inject(Router);

  const requiredRaw = route.data['roles'] as unknown;

  if (requiredRaw === 'OK' || requiredRaw === Roles.OK) {
    return true;
  }

  const requiredList: Roles[] = Array.isArray(requiredRaw)
    ? (requiredRaw as Roles[])
    : requiredRaw
      ? [requiredRaw as Roles]
      : [];
  if (!requiredList.length) {
    return true;
  }

  const userRoles = userService.userSignal()?.roles ?? [];
  const hasAccess = userRoles.some(
    role => !!role.title && requiredList.includes(role.title as Roles)
  );

  return hasAccess ? true : router.createUrlTree(['/404']);
};
